import React from 'react';
import { Link } from 'react-router-dom';

const CarCard = ({ car }) => {
  const handleCardClick = () => {
    // Scroll to top when navigating to detail page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDetailsClick = (e) => {
    // Scroll to top when navigating to detail page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-slate-100">
      <div className="relative bg-white h-72 overflow-hidden flex items-center justify-center">
        <img
          src={car.image}
          alt={`${car.brand} ${car.model} ${car.year} - Color disponible, ${car.fuel}, ${car.transmission}`}
          className="max-w-full max-h-full object-contain"
        />
      </div>
      <div className="p-5">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-xl font-bold text-slate-700">
            {car.brand} {car.model}
          </h3>
          <div className="flex flex-col items-end gap-1">
            <span className="text-sm text-slate-500 bg-slate-50 pr-0 px-3 py-1 rounded-full">
              Año {car.year}
            </span>
          </div>
        </div>
        
        {/* Professional Price and Kilometers Section */}
        <div className="bg-gradient-to-r from-slate-50 to-sky-50 rounded-xl pt-2 mb-4 border border-slate-200">
          <div className="flex justify-between items-center max-sm:justify-start">
            <div className="flex flex-col">
              <span className="text-xs text-slate-500 font-medium mb-1">
                {car.sold ? 'Estado' : 'Precio'}
              </span>
              <span className={`text-xl font-bold ${car.sold ? 'text-red-600' : 'text-sky-600'}`}>
                {car.sold ? 'VENDIDO' : `$${car.price?.toLocaleString('es-AR')}`}
              </span>
            </div>
            <div className="flex flex-col items-end hidden sm:block">
              <span className="text-xs text-slate-500 font-medium mb-1">Km</span>
              <span className="text-lg font-semibold text-slate-700">
                {car.kilometers?.toLocaleString('es-AR')}
              </span>
            </div>
          </div>
        </div>
        <Link
          to={`/car/${car.id}`}
          onClick={handleDetailsClick}
          className="block w-full bg-gradient-to-r from-sky-600 to-sky-700 hover:from-sky-700 hover:to-sky-800 text-white text-center py-3 px-4 rounded-xl transition-all duration-200 font-medium shadow-sm hover:shadow-md"
        >
          Ver Detalles
        </Link>
      </div>
    </div>
  );
};

export default CarCard;
